import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NotificationProvider } from './components/Notification';
import { AccessibilityProvider } from './context/AccessibilityContext';
import { CookieConsentProvider } from './context/CookieConsentContext';
import { LanguageProvider } from './context/LanguageContext';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AccessibilityProvider>
<CookieConsentProvider>
        <LanguageProvider>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </LanguageProvider>
      </CookieConsentProvider>
      </AccessibilityProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
